module.exports = __webpack_public_path__ + "static/media/logoPoliciaZaragoza.a6169423.jpg";